/**
 * The TV scorebug on the field: score bar (possession arrow, team blocks, scores) over the game
 * bar (period and clock, the play clock slot hidden in single player, down and distance and the
 * ball spot). It shows a `ScorebugText` as given.
 */
import type { TeamId } from '@tdmons/sim';
import type { ScorebugText } from '../game/scorebug';

export class ScorebugView {
  constructor(private readonly root: HTMLElement) {}

  show(s: ScorebugText): void {
    for (const t of ['A', 'B'] as TeamId[]) {
      this.part(`.sb-tag[data-team="${t}"]`).textContent = s.tags[t];
      this.part(`.sb-pts[data-team="${t}"]`).textContent = s.score[t];
      this.part(`.sb-team-${t.toLowerCase()}`).classList.toggle('has-ball', s.possession === t);
    }
    this.part('.sb-period').textContent = s.period;
    this.part('.sb-down').textContent = [s.down, s.spot].filter(Boolean).join(' · ');
    this.root.setAttribute(
      'aria-label',
      `${s.tags.A} ${s.score.A}, ${s.tags.B} ${s.score.B}. ${s.period}. ${s.tags[s.possession]} ball, ${s.down} ${s.spot}`,
    );
  }

  /** The text on the bug, as a person reads it (what the tests compare). */
  read(): string {
    return [...this.root.querySelectorAll<HTMLElement>('.sb-tag, .sb-pts, .sb-period, .sb-down')]
      .map((e) => e.textContent ?? '')
      .join(' ');
  }

  private part(sel: string): HTMLElement {
    const e = this.root.querySelector<HTMLElement>(sel);
    if (!e) throw new Error(`the scorebug needs ${sel}`);
    return e;
  }
}
